var headerBackground = {
    $headerBackground: $('.header-bg-grey-shape'),

    init: function() {
        var _this = this;

        _this.listener();
    },

    listener: function() {
        var _this = this;
        var timer;

        if ($('.bg-grey-shape').length !== 0) {
            _this.calcBackgroundOffset();
        } else if ($('.bg-grey-shape-home').length !== 0) {
            _this.calcHomeBackgroundOffset();
        }

        $(window).on('resize', function() {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function() {
                if ($('.bg-grey-shape').length !== 0) {
                    _this.calcBackgroundOffset();
                } else if ($('.bg-grey-shape-home').length !== 0) {
                    _this.calcHomeBackgroundOffset();
                }
            }, 200);
        });
    },

    calcBackgroundOffset: function() {
        var offsetContainer;
        var rightMenuSize;
        var totalOffset;

        offsetContainer = $('.header-detail-page-block section').offset().left;
        rightMenuSize = $('nav .holder').width();
        totalOffset = offsetContainer + rightMenuSize;

        $('.bg-grey-shape').css('right', `${totalOffset}px`);
    },

    calcHomeBackgroundOffset: function() {
        var offsetContainer;
        var logoSize;
        var totalOffset;
        console.log('test');
        offsetContainer = $('.home-header section').offset().left;
        logoSize = $('nav .logo').width();
        totalOffset = offsetContainer + logoSize + 60;

        $('.bg-grey-shape-home').css('left', `${totalOffset}px`);
    }
};
